import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#253D8D', //blue-green
      light: '#8ecae6', //sky-blue
      dark: '#172553',  //darker version of logo blue
    },
    secondary: {
      main: '#F3B232', //selective-yellow
      dark: '#fb8500', //ut-orange
    },
  },
  typography: {
    fontFamily: [
      'Poppins',
      'Noto Sans',
      'Arial',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'sans-serif',
    ].join(','),
    h2: {
      fontFamily: ['Poppins', 'Arial'],
      fontWeight: 'bold',
    },
    h3: {
      fontSize: '2.8rem',
    },
  }
});

export default theme; 